import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { notification } from 'antd';

const useQrUserData = (nhGuideNumber) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchUserData = useCallback(async () => {
    if (!nhGuideNumber) {
      setUserData(null);
      setLoading(false);
      return;
    }

    try {
      // Récupérer les données de l'utilisateur en utilisant nhGuideNumber
      const response = await fetch(
        `/backend/get_user_email_by_nhGuideNumber.php?nhGuideNumber=${encodeURIComponent(nhGuideNumber)}`,
        {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.user_email) {
        throw new Error('No user found with this NH Guide Number');
      }

      // Créer un objet userData avec les informations récupérées
      const fullName = [data.firstName, data.lastName].filter(Boolean).join(' ') || data.userName || `User (NH: ${nhGuideNumber})`;
      const location = [data.street, data.city].filter(Boolean).join(', ') || 'Location not set';

      setUserData({
        name: fullName,
        location,
        nhNumber: nhGuideNumber,
        userEmail: data.user_email,
        avatar: data.profile_picture || null,
        notifications: 0,
        lastLogin: new Date().toLocaleDateString(),
        role: 'Member',
        firstName: data.firstName,
        lastName: data.lastName,
        userName: data.userName,
        street: data.street,
        city: data.city,
      });

    } catch (err) {
      console.error('Error fetching user data:', err);
      setError(err.message);
      setUserData({
        name: `Unknown User (NH: ${nhGuideNumber})`,
        location: 'Location not available',
        nhNumber: nhGuideNumber,
        userEmail: null,
        avatar: null,
        notifications: 0,
        lastLogin: new Date().toLocaleDateString(),
        role: 'Guest',
      });
    } finally {
      setLoading(false);
    }
  }, [navigate, nhGuideNumber]);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  return { userData, loading, error, refetch: fetchUserData };
};

export default useQrUserData;
